enum Api {
    SPOTIFY = 'SPOTIFY',
};

export default Api;
